import { DashboardModule, LoadingModule } from '@domain-group/suit-theme'

import useActivities, { ActivityFilters } from '@hooks/useActivities'

import ActivityItem from '@components/ActivityListItem'
import BlankState from '@components/EntityActivity/BlankState'

import type { ActivityRequestOptions } from '@models/types'

import ActivityImageUrl from '@assets/activity.svg'

interface ActivityProps {
  boxProps?: object,
  disableLoading?: boolean,
  filters?: ActivityFilters,
  itemProps?: object,
  requestOptions?: ActivityRequestOptions,
  subjectId: number,
  subjectType: string,
}

const Activity = (props: ActivityProps) => {
  const {
    boxProps, disableLoading, filters, itemProps, requestOptions, subjectId, subjectType,
  } = props

  const activitiesPayload = useActivities({
    filters: {
      recipient_type: subjectType,
      recipient_id: subjectId,
      ...filters,
    },
    performHttpRequests: !!subjectId,
    requestOptions,
  })

  const {
    filteredActivities,
    hasFilteredActivities,
    loading,
  } = activitiesPayload

  const displayedActivitiesArray = filteredActivities.slice(0, filters?.limit || 10)
  const displayedActivitiesArrayCount = displayedActivitiesArray.length

  return (
    <DashboardModule.ScrollableSection
      // @ts-expect-error TS2322
      alignItems={hasFilteredActivities ? undefined : 'center'}
      flexDirection="column"
      height="100%"
      justifyContent={hasFilteredActivities ? undefined : 'center'}
      marginTop="large"
      maxHeight={406}
      {...boxProps}
    >
      {/*
       // @ts-expect-error TS2741 */}
      {!disableLoading && loading && <LoadingModule boxProps={{ marginBottom: 0 }} />}

      {!loading && !hasFilteredActivities && (
        <BlankState
          imageUrl={ActivityImageUrl}
          title="No Activity"
          subtitle="Activity will be logged here once work starts."
        />
      )}

      {displayedActivitiesArray.map((activity, index) => (
        <ActivityItem
          activity={activity}
          isLastActivity={index === (displayedActivitiesArrayCount - 1)}
          key={activity.id}
          {...itemProps}
        />
      ))}
    </DashboardModule.ScrollableSection>
  )
}

export default Activity
